export enum AlertType {
    NEW_UNASSIGNED_EVENT = 'new_unassigned_event',
    AED_ATTEMPTING_ACCEPTING = 'aed_attempting_accepting',
}
